// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { List } from "@material-ui/core";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
// src
import DraggableGroup from "./DraggableGroup";
import EditableLine from "../EditableLine";

const PlanningList = ({
  // parent props
  dispatch,
  tree,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [mine, ...others] = tree;

  // UX
  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = (result) => {
    setIsDragging(false);
    if (!result.destination) return;
    dispatch({ type: "move", from: result.source.index, to: result.destination.index });
  };

  const listClassName = isDragging ? "dragging plannings" : "plannings";
  return (
    <>
      <List className={listClassName}>
        <EditableLine preset={mine[0]} dispatch={dispatch} />
        <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {others.map((g) => (
                  <DraggableGroup key={g[0].id} group={g} dispatch={dispatch} provided={provided} />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </List>
    </>
  );
};

PlanningList.propTypes = {
  // parents props
  dispatch: PropTypes.func.isRequired,
  tree: PropTypes.array.isRequired,
};

export default PlanningList;
